import { request } from '@@/plugin-request';

export async function queryAll(payload) {
  return request('/api/educationalResearchTasks/queryAll', { method: 'get', params: payload });
}
export async function deleteById(payload) {
  return request('/api/educationalResearchTasks/deleteById', { method: 'put', data: payload });
}
export async function transferQualityLessonTask(payload) {
  return request('/api/educationalResearchTasks/transferQualityLessonTask', {
    method: 'put',
    data: payload,
  });
}

export async function deleteQualityLessonTask(payload) {
  return request('/api/educationalResearchTasks/deleteQualityLessonTask', {
    method: 'put',
    data: payload,
  });
}

export async function queryQualityLessonTasks(payload) {
  return request('/api/educationalResearchTasks/queryQualityLessonTasks', {
    method: 'get',
    params: payload,
  });
}

export async function getVideoReviewUsers(params) {
  return request('/api/educationalResearchTasks/videoReviewUsers', { method: 'get', params });
}

export async function startRandomVideoAiReview(taskId, payload) {
  return request(`/api/educationalResearchTasks/${taskId}/randomVideoAiReview`, {
    method: 'post',
    data: payload,
  });
}

export async function getRandomVideoAiReview(taskId) {
  return request(`/api/educationalResearchTasks/${taskId}/randomVideoAiReview`, {
    method: 'get',
  });
}

export async function getRandomVideoAiReviewProgress(taskIds) {
  return request('/api/educationalResearchTasks/randomVideoAiReviewProgress', {
    method: 'get',
    params: { taskIds: taskIds.join(',') },
  });
}

// 新流程「负面特征风险说明」，独立于原有 AI 预审
export async function getNegativeFeatures(taskId) {
  return request(`/api/educationalResearchTasks/${taskId}/negativeFeatures`, { method: 'get' });
}

export async function recomputeNegativeFeatures(taskId) {
  return request(`/api/educationalResearchTasks/${taskId}/negativeFeatures/recompute`, {
    method: 'post',
  });
}

export async function regenerateRandomVideoAiReview(taskId) {
  return request(`/api/educationalResearchTasks/${taskId}/randomVideoAiReview/regenerate`, {
    method: 'post',
  });
}

export async function reprocessRandomVideoRead(taskId) {
  return request(`/api/educationalResearchTasks/${taskId}/randomVideoAiReview/reprocessVideoRead`, {
    method: 'post',
  });
}

export async function askRandomVideoAiReview(taskId, payload) {
  return request(`/api/educationalResearchTasks/${taskId}/randomVideoAiReview/ask`, {
    method: 'post',
    data: payload,
  });
}

export const EducationalResearchTaskCategory = {
  过课: '过课',
  抽查视频审核: '抽查视频审核',
  课诉视频审核: '课诉视频审核',
  面试结果反馈: '面试结果反馈',
  教务协助工作: '教务协助工作',
  其他教研工作: '其他教研工作',
  '上课（字数）': '上课（字数)',
  '上课（时长）': '上课（时长)',
  教师评级: '教师评级',
  投诉处理: '投诉处理',
  //首课课前沟通: '首课课前沟通',
  投诉预警处理: '投诉预警处理',
};
